import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Grid, Typography} from "@material-ui/core";

class PBNResult extends Component {
    render() {
        let finalContract = <></>;
        if (this.props.pbnContract !== "") {
            let contract = this.props.pbnContract;
            let theRank = contract.substring(0, 1);
            let doubled = contract.substring(contract.length - 2, contract.length);

            let finalDoubled = <></>;
            if(doubled === "XX") {
                finalDoubled = <Typography variant={"body1"} color={"primary"} inline>XX</Typography>;
            } else if(doubled.substring(1, 2) === "X") {
                finalDoubled = <Typography variant={"body1"} color={"primary"} inline>X</Typography>;
            }

            switch (this.props.trumps) {
                case 0:
                    finalContract = (
                        <>
                            <Typography variant={"body1"} color={"primary"} inline>{ theRank }</Typography>
                            <Typography variant="body1" inline style={{color:"#000000"}}>&spades;</Typography>
                            {finalDoubled}
                        </>
                    );
                    break;
                case 1:
                    finalContract = (
                        <>
                            <Typography variant={"body1"} color={"primary"} inline>{ theRank }</Typography>
                            <Typography variant="body1" inline style={{color:"#F44336"}}>&hearts;</Typography>
                            {finalDoubled}
                        </>
                    );
                    break;
                case 2:
                    finalContract = (
                        <>
                            <Typography variant={"body1"} color={"primary"} inline>{ theRank }</Typography>
                            <Typography variant="body1" inline style={{color:"#F44336"}}>&diams;</Typography>
                            {finalDoubled}
                        </>
                    );
                    break;
                case 3:
                    finalContract = (
                        <>
                            <Typography variant={"body1"} color={"primary"} inline>{ theRank }</Typography>
                            <Typography variant="body1" inline style={{color:"#000000"}}>&clubs;</Typography>
                            {finalDoubled}
                        </>
                    );
                    break;
                case 4:
                    finalContract = (
                        <>
                            <Typography variant={"body1"} color={"primary"} inline>{ theRank } {'NT'}</Typography>
                            {finalDoubled}
                        </>
                    );
                    break;
                default:
                    finalContract = <></>
            }
        }

        let declarer = '';

        switch (this.props.pbnDeclarer) {
            case 0:
                declarer = 'North';
                break;
            case 1:
                declarer = 'East';
                break;
            case 2:
                declarer = 'South'
                break;
            case 3:
                declarer = 'West'
                break;
        }

        return (
            <Grid container style={{padding:'5px'}}>
                <Grid item xs={12}>
                    <Typography variant={"body1"} inline>Contract: </Typography>
                    {finalContract}
                </Grid>
                <Grid item xs={12}>
                    <Typography variant={"body1"} inline>Declarer: </Typography>
                    <Typography variant={"body1"} inline color={"primary"}>{declarer}</Typography>
                </Grid>
                <Grid item xs={12} wrap={"nowrap"}>
                    <Typography variant={"body1"} inline>Result:: </Typography>
                    <Typography variant={"body1"} inline color={"primary"}>{this.props.pbnResult}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant={"body1"}>&nbsp;</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant={"body1"}>&nbsp;</Typography>
                </Grid>
            </Grid>
        );
    }
}

PBNResult.propTypes = {
    trumps: PropTypes.string,
    pbnContract: PropTypes.string,
    pbnDeclarer: PropTypes.string,
    pbnResult: PropTypes.string,
    pbnScoring: PropTypes.string
}

export default PBNResult;